import { fromDBToLocalDateTime } from '@pinnacleautomotive/clarity-components';

const isValidKey = (obj, key, type) => {
  if (type) return Object.prototype.hasOwnProperty.call(obj, key);
  return (
    Object.prototype.hasOwnProperty.call(obj, key) &&
    obj[key] !== undefined &&
    obj[key] !== null &&
    obj[key] !== ''
  );
};

export const sortGroupedByDate = grouped => {
  const sortTypeByDate = type => {
    const sorted = {};
    Object.keys(grouped[type])
      .sort((a, b) => new Date(a) - new Date(b))
      .forEach(key => {
        sorted[key] = grouped[type][key];
      });
    return sorted;
  };

  return {
    packages: sortTypeByDate('packages'),
    estimates: sortTypeByDate('estimates'),
  };
};

export const groupByDateAndType = data => {
  const grouped = {
    packages: {},
    estimates: {},
  };
  const addToGrouped = (item, type) => {
    const date = new Date(item?.dateOrdered || item.date);
    const dateStr = fromDBToLocalDateTime(date);
    if (!grouped[type][dateStr]) {
      grouped[type][dateStr] = [];
    }
    grouped[type][dateStr].push(item);
  };
  data?.packages?.map(pkg => addToGrouped(pkg, 'packages'));
  data?.estimates?.map(est => addToGrouped(est, 'estimates'));

  return grouped;
};

export const getValueIfPresent = (obj, key) => {
  if (
    Object.prototype.hasOwnProperty.call(obj, key) &&
    obj[key] !== undefined &&
    obj[key] !== null &&
    obj[key] !== ''
  ) {
    return obj[key];
  } else {
    return null;
  }
};
/* this function takes the data incoming from the set ne ros, the keys of the object composed by an array of the id of the workorders on each group an the value is the value to change */
export const swapKeysAndValues = (obj, type) => {
  const swapped = {};
  for (const key in obj) {
    if (isValidKey(obj, key, type)) {
      const value = obj[key.split(',')];
      swapped[value] ||= [];
      swapped[value] = [...swapped[value], ...key.split(',')];
    }
  }
  return swapped;
};

export const collectIds = orders => {
  return orders.map(order => order.vendorOrderId).join(',');
};

export const sumAmount = arr => {
  return arr.reduce((total, item) => {
    return total + (item['amount'] || 0);
  }, 0);
};

const checkRoEquality = orders => {
  return orders.every((val, i, arr) => val.repairOrder === arr[0].repairOrder);
};

export const setRoLabels = (
  checked,
  packageRo,
  currentOrderRos,
  emptyLabel
) => {
  if (checked && packageRo) return packageRo;
  if (
    !checked &&
    checkRoEquality(currentOrderRos) &&
    currentOrderRos[0].repairOrder
  )
    return currentOrderRos[0].repairOrder;
  return emptyLabel;
};
